import { useMutation, useQueryClient } from "@tanstack/react-query";

import axiosInstance from "@/api/axiosInstance";

const patchReadNotify = async (notificationId: string) => {
  const response = await axiosInstance.patch(`/api/v1/admin/notifications/${notificationId}/read`);
  return response.data;
};

export const usePatchReadNotify = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (notificationId: string) => patchReadNotify(notificationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });
      queryClient.invalidateQueries({ queryKey: ["notificationUnreadCount"] });
    },
  });
};
